import axios from 'axios';
import { vm } from '@/main.js'

const openapi = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
})


openapi.interceptors.request.use(
    async config => {
        // const token = localStorage.getItem("token")
        config.headers = {
            //     'Authorization': `Bearer ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded'
        }
        return config;
    },
    error => {
        Promise.reject(error)
    });


openapi.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response.status === 401) {
            console.log("Unauthorized")
            vm.$store.dispatch("logout")
            vm.$router.push({ name: 'login' });
        } else if (error.response.status === 422) {
            if (error.response.data.errors) {
                console.alert(error)
                    // for (let key in error.response.data.errors) {
                    // vm.$validator.errors.add({ field: key, msg: error.response.data.errors[key] })
                    // }
            }
        } else {
            console.error(error)
        }
        return Promise.reject(error);
    })

export default openapi